import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Pricing from "../components/Pricing";

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-[#EDF1FB]">
      <Navbar variant="solid" />
      <section className="relative overflow-hidden nst-navy text-white pt-[120px] pb-16">
        <div className="absolute inset-0 bg-grid-dark opacity-40" />
        <div
          className="glow-orb w-[420px] h-[420px] -top-20 -left-20"
          style={{ background: "#2E6BF6" }}
        />
        <div
          className="glow-orb w-[520px] h-[520px] top-20 -right-32"
          style={{ background: "#16C47F" }}
        />
        <div className="relative max-w-[1280px] mx-auto px-6 lg:px-10">
          <div className="max-w-3xl">
            <span className="pill-label on-dark">Simple, outcome-based pricing</span>
            <h1 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight">
              Ship the platform your team deserves
            </h1>
            <p className="mt-6 text-lg text-white/80 leading-relaxed">
              Four tiers. Start free, upgrade when you're ready. Every paid tier is backed by real architects and production-grade tooling.
            </p>
          </div>
        </div>
      </section>
      <Pricing compact />
      <Footer />
    </div>
  );
}
